function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.5 1C8.5 7 18.9084 12.0474 27.9007 17.2929C34.9443 21.4017 43.2726 23.4965 51.1835 25.3991C63.2662 28.3051 75.8317 31.0734 88.3369 31.0734C89.2768 31.0734 92.1922 32.5261 90.9939 30.2628C89.7578 27.9279 87.4628 25.2629 85.905 22.9672C83.7634 19.8111 82.3889 15.9241 80.8161 12.4292C79.8634 10.3119 79.8254 11.1845 79.8254 13.2398C79.8254 17.4996 83.9945 23.8828 87.3011 26.2097C88.3017 26.9139 94.3265 30.0707 94.3265 31.5238C94.3265 32.603 89.7165 33.4344 88.7422 34.3159C86.84 36.037 83.9902 37.9042 83.0679 40.4406C82.4127 42.2422 79.9687 44.1246 79.8254 45.8447C79.7332 46.9511 79.0345 49.3025 78.2041 49.7177",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 51,
    viewBox: "0 0 95 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ae8c0263.svg";
export { ForwardRef as ReactComponent };